/* JoyForm weight plate live preview (tag jf:plate-preview).
   Runs next to keychain-personalizer.js, which still owns the swatches and
   their hidden inputs; this script only reads the form and drives
   jf-plate-3d.js over the product gallery.

   Fields are found by their property names, which map 1:1 onto the
   Customizable Weight Plate SCAD script:
     properties[Name]            LINE_1_TEXT  (top, outer)
     properties[Line 2 ...]      LINE_2_TEXT  (top, inner)
     properties[Line 3 ...]      LINE_3_TEXT  (bottom, inner)
     properties[Line 4 ...]      LINE_4_TEXT  (bottom, outer)
     properties[Weight ...]      WEIGHT_TOP_TEXT
     properties[Unit]            WEIGHT_BOTTOM_TEXT
     colour slot c1 / c2         plate / text filament
   Text is upper-cased as it is typed so the order matches the preview.
   Palette = Patron filament stock plus Bambu PLA Translucent Lavender (also in
   keychain-personalizer.liquid, keychain-personalizer.js and
   color-model-stage.liquid - change all four). */
(function () {
  var COLORS = {
    "Green":        { hex: "#04AD73" },
    "Baby Pink":    { hex: "#FDBCDD" },
    "Flamingo Pink":{ hex: "#E87668" },
    "Brown":        { hex: "#59302C" },
    "Black":        { hex: "#1B1C28" },
    "Blue":         { hex: "#07298C" },
    "Baby Blue":    { hex: "#03BBFD" },
    "Lavender":     { hex: "#B8ACD6" },
    "Beige":        { hex: "#FCDBB3" },
    "Marble White": { hex: "#D3D5E3", fleck: "#62595B" },
    "Marble Brown": { hex: "#D1B380", fleck: "#5D4017" }
  };
  var DEFAULTS = { plate: "Black", text: "Marble White" };
  var PLACEHOLDERS = ["YOUR NAME", "", "", ""];
  var MAX_LINE = 14;

  var GALLERY_SELECTORS = [
    "media-gallery",
    ".product-media-container",
    "[class*='product-media-gallery']",
    ".product-media",
    "slideshow-component"
  ];

  function findGallery() {
    for (var i = 0; i < GALLERY_SELECTORS.length; i++) {
      var el = document.querySelector(GALLERY_SELECTORS[i]);
      if (el && el.offsetParent !== null) return el;
    }
    return null;
  }

  /* Same module hand-off as keychain-personalizer.js: Shopify rewrites
     dynamic imports in classic theme scripts. */
  var plateReady = null;
  function loadPlate3D(url) {
    plateReady = plateReady || new Promise(function (resolve, reject) {
      window.__jfPlate3D = function (err, mod) {
        delete window.__jfPlate3D;
        if (err || !mod) reject(err || new Error("jf-plate-3d did not load"));
        else resolve(mod);
      };
      var script = document.createElement("script");
      script.type = "module";
      script.textContent = "imp" + "ort(" + JSON.stringify(url) + ")" +
        ".then(function (m) { window.__jfPlate3D(null, m); })" +
        ".catch(function (e) { window.__jfPlate3D(e); });";
      document.head.appendChild(script);
    });
    return plateReady;
  }

  function field(root, prefix) {
    var all = root.querySelectorAll("input[name^='properties['], select[name^='properties[']");
    for (var i = 0; i < all.length; i++) {
      if (all[i].name.indexOf("properties[" + prefix) === 0) return all[i];
    }
    return null;
  }

  function upper(input) {
    input.addEventListener("input", function () {
      var start = input.selectionStart, end = input.selectionEnd;
      var next = input.value.toUpperCase();
      if (next !== input.value) {
        input.value = next;
        try { input.setSelectionRange(start, end); } catch (e) { /* number inputs */ }
      }
    });
  }

  function init(root) {
    if (root.dataset.jfPlateReady) return;
    var cfg = null;
    try { cfg = JSON.parse(root.getAttribute("data-jf-plate") || ""); } catch (e) { cfg = null; }
    if (!cfg || !window.WebGLRenderingContext) return;
    root.dataset.jfPlateReady = "1";

    var lines = [
      root.querySelector("[data-jf-name]"),
      field(root, "Line 2"),
      field(root, "Line 3"),
      field(root, "Line 4")
    ];
    var weightIn = field(root, "Weight");
    var unitIn = field(root, "Unit");
    var plateIn = root.querySelector('[data-jf-value="c1"]');
    var textIn = root.querySelector('[data-jf-value="c2"]');

    var examples = ["e.g. YOUNIS", "e.g. TEAM", "e.g. BEAST", "e.g. MODE ON"];
    lines.forEach(function (input, i) {
      if (!input) return;
      input.maxLength = MAX_LINE;
      input.placeholder = examples[i];
      upper(input);
    });
    if (weightIn) {
      weightIn.maxLength = 5;
      weightIn.placeholder = "e.g. 25";
    }

    /* Stage over the gallery, shown once the 3D view is ready. */
    var host = findGallery();
    var stage = document.createElement("div");
    stage.className = "jf-overlay jf-overlay--3d";
    stage.innerHTML = '<div class="jf-3d"></div><p class="jf-cap">Your plate, live in 3D. Drag to spin it.</p>';
    var toggle = null;
    if (host) {
      if (window.getComputedStyle(host).position === "static") host.style.position = "relative";
      stage.classList.add("jf-overlay--pinned");
      host.appendChild(stage);
      toggle = document.createElement("button");
      toggle.type = "button";
      toggle.className = "jf-toggle";
      toggle.hidden = true;
      toggle.textContent = "Show photos";
      host.appendChild(toggle);
    } else {
      stage.classList.add("jf-overlay--inline");
      (root.querySelector("[data-jf-fallback]") || root).appendChild(stage);
    }

    var userHid = false;
    if (toggle) {
      toggle.addEventListener("click", function () {
        userHid = !userHid;
        toggle.textContent = userHid ? "Show my plate" : "Show photos";
        stage.classList.toggle("is-on", !userHid);
      });
    }

    var view = null, pending = 0;

    function color(input, fallback) {
      return COLORS[(input && input.value) || fallback] || COLORS[fallback];
    }

    function state() {
      return {
        lines: lines.map(function (input, i) {
          var v = input ? input.value.trim().toUpperCase() : "";
          return v || PLACEHOLDERS[i];
        }),
        weight: (weightIn && weightIn.value.trim()) || "25",
        unit: (unitIn && unitIn.value) || "KG",
        colors: { plate: color(plateIn, DEFAULTS.plate), text: color(textIn, DEFAULTS.text) }
      };
    }

    function refresh() {
      if (!view) return;
      clearTimeout(pending);
      pending = setTimeout(function () {
        view.update(state()).catch(function (err) { console.warn("[jf-plate-3d]", err); });
      }, 60);
    }

    /* Swatch clicks bubble here after keychain-personalizer.js has set the hidden input. */
    root.addEventListener("input", refresh);
    root.addEventListener("change", refresh);
    root.addEventListener("click", function (e) {
      if (e.target.closest && e.target.closest(".jf-swatch")) refresh();
    });

    loadPlate3D(cfg.module)
      .then(function (api) { return api.createPlate3D(stage.querySelector(".jf-3d"), cfg); })
      .then(function (v) {
        view = v;
        return view.update(state());
      })
      .then(function () {
        stage.classList.add("is-on");
        if (toggle) toggle.hidden = false;
      })
      .catch(function (err) {
        console.warn("[jf-plate-3d]", err);
        stage.remove();
        if (toggle) toggle.remove();
      });
  }

  function boot() {
    document.querySelectorAll(".jf-personalizer[data-jf-plate]").forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else { boot(); }
  document.addEventListener("shopify:section:load", boot);
})();
